const BASE_KEY = 'settings.materials.material-definitions.delete.bulk';

export const BULK_DELETE_MATERIALS_NOTIFICATION_KEY = {
    success: `${BASE_KEY}.notifications.success`,
    partial: `${BASE_KEY}.notifications.partial`,
    error: `${BASE_KEY}.notifications.error`,
} as const;
